import { render, staticRenderFns } from "./FilterPeriodLabel.vue?vue&type=template&id=17e5450b&scoped=true"
import script from "./FilterPeriodLabel.vue?vue&type=script&lang=ts"
export * from "./FilterPeriodLabel.vue?vue&type=script&lang=ts"
import style0 from "./FilterPeriodLabel.vue?vue&type=style&index=0&id=17e5450b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17e5450b",
  null
  
)

/* custom blocks */
import block0 from "@/i18n/components/filter/filter-period.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fusergram-front%2Fsrc%2Fcomponents%2Ffilter%2FFilterPeriodLabel.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports